import InputField from '../../inputs/inputField'
import CalendarInput from '../../inputs/calendarInput'
import TypographyParagraph from '../../typography/TypographyParagraph'
import Toggle from '../../inputs/toggle'
import { useEffect } from 'react'

export default function OffchainSaleForm({
	formData,
	setFormData,
	requiredFields,
	errorFields,
}: {
	formData: any
	setFormData: (data: any) => void
	requiredFields: any[]
	errorFields: any[]
}) {
	useEffect(() => {
		// Default to countersign required
		if (Object.keys(formData).length == 0) {
			setFormData({ countersignRequired: true })
		}
	}, [formData])

	const handleDataChange = (name: string, value: any) => {
		let newData = { ...formData }
		newData[name] = value
		setFormData(newData)
	}

	return (
		<div className="flex w-full flex-col gap-y-2">
			<CalendarInput
				name="date"
				containerWidth="w-full"
				value={formData.date}
				displayRequired={requiredFields.find(field => field.slug == 'date')}
				onChange={e => {
					handleDataChange('date', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'date',
				)}
			/>
			<InputField
				name="owner address"
				type="text"
				placeholder="Enter owner address"
				containerWidth="w-full"
				value={formData.ownerAddress}
				displayRequired={requiredFields.find(
					field => field.slug == 'ownerAddress',
				)}
				onChange={e => {
					handleDataChange('ownerAddress', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'ownerAddress',
				)}
			/>
			<InputField
				name="receiver address"
				type="text"
				placeholder="Enter receiver address"
				containerWidth="w-full"
				value={formData.receiverAddress}
				displayRequired={requiredFields.find(
					field => field.slug == 'receiverAddress',
				)}
				onChange={e => {
					handleDataChange('receiverAddress', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'receiverAddress',
				)}
			/>
			<div className="flex flex-row gap-x-4">
				<div className="w-1/2">
					<InputField
						name="amount"
						type="number"
						placeholder="Ex. 1.52"
						containerWidth="w-full"
						value={formData.amount}
						displayRequired={requiredFields.find(
							field => field.slug == 'amount',
						)}
						onChange={e => {
							handleDataChange('amount', e.target.value)
						}}
						isError={errorFields.find(
							requiredField => requiredField.slug == 'amount',
						)}
					/>
				</div>
				<div className="w-1/2">
					<InputField
						name="currency"
						type="text"
						placeholder='Ex. "ETH"'
						containerWidth="w-full"
						value={formData.currency}
						displayRequired={requiredFields.find(
							field => field.slug == 'currency',
						)}
						onChange={e => {
							handleDataChange('currency', e.target.value)
						}}
						isError={errorFields.find(
							requiredField => requiredField.slug == 'currency',
						)}
					/>
				</div>
			</div>
			<InputField
				name="transaction hash"
				type="text"
				placeholder='Ex. "0xf0640101e93fd4930393c05d1e244d9d6ce162eb852473353d4657205a2bbe38"'
				containerWidth="w-full"
				value={formData.transactionHash}
				displayRequired={requiredFields.find(
					field => field.slug == 'transactionHash',
				)}
				onChange={e => {
					handleDataChange('transactionHash', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'transactionHash',
				)}
			/>
			<InputField
				name="url"
				type="text"
				placeholder="https://"
				containerWidth="w-full"
				value={formData.url}
				displayRequired={requiredFields.find(field => field.slug == 'url')}
				onChange={e => {
					handleDataChange('url', e.target.value)
				}}
				isError={errorFields.find(requiredField => requiredField.slug == 'url')}
			/>
			<InputField
				name="description"
				lines={4}
				placeholder="Add context to this offchain history signature"
				containerWidth="w-full"
				additionalClasses="h-32"
				value={formData.description}
				displayRequired={requiredFields.find(
					field => field.slug == 'description',
				)}
				onChange={e => {
					handleDataChange('description', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'description',
				)}
			/>
			<div className="mt-2 flex flex-row">
				<Toggle
					name={''}
					isEnabled={formData.countersignRequired}
					onEnabledChange={newEnabled =>
						handleDataChange('countersignRequired', newEnabled)
					}
				></Toggle>
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
				>
					<b>Require Countersign: </b>Choose to require a countersignature for
					this attestation. If selected, the signature awaits countersigning;
					otherwise, it's complete upon submission.
				</TypographyParagraph>
			</div>
		</div>
	)
}
